import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {keyOutline, keySharp} from "ionicons/icons"
import {useHistory} from "react-router";
import TimeLimit from "@customTypes/TimeLimit";

interface props {
    timeLimit: TimeLimit
}

const ListItemButtonTimeLimit: React.FC<props> = ({ timeLimit }) => {

    const { t } = useTranslation()
        , history = useHistory()
        , [presentAlert] = useIonAlert()
        , keyTimeLimitsCount: number = timeLimit.keyTimeLimits?.length || 0
        , translationKey: string = "time-limits.alerts." + (keyTimeLimitsCount ? 'keys' : 'no_keys')

    const alertMessage = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t(translationKey + '.header'),
            message: t(translationKey + '.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    const goToTimeLimitKeys = (ev: any) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (timeLimit.keyTimeLimits) {
            return history.push('/time-limits/' + timeLimit.id + '/keys')
        }

        alertMessage(ev).then()
    }

    return (
        <IonButton color={keyTimeLimitsCount > 0 ? "medium" : "light"} fill="clear"
                   onClick={ (ev) => goToTimeLimitKeys(ev) }
                   shape="round" size="large" style={{ 'fontSize': '1rem' }}>
            <IonIcon slot="start" ios={keyOutline} md={keySharp} />
            {keyTimeLimitsCount || '-'}
        </IonButton>
    )
}

export default ListItemButtonTimeLimit